import { render, staticRenderFns } from "./SalaForm.vue?vue&type=template&id=6bbb8bb8&scoped=true&"
import script from "./SalaForm.vue?vue&type=script&lang=js&"
export * from "./SalaForm.vue?vue&type=script&lang=js&"
import style0 from "./SalaForm.vue?vue&type=style&index=0&id=6bbb8bb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbb8bb8",
  null
  
)

export default component.exports